function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreatachain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.434,
    height: 38.801,
    viewBox: "0 0 33.434 38.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15975"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15974"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15971"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 846",
    d: "m209.057 334.091-.244.158-11.024.6-10.65 4.772c1.686-.941 3.9-2.133 5.837-3.172 2.437-1.3 4.446-2.361 4.446-2.361z",
    transform: "translate(-186.524 -311.013)",
    style: {
      fill: "#013eb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 847",
    d: "m206.778 334.774-1.673 1.074-3.882 2.494-3.746 2.408-1.635 1.052 5.381 8.467v.032l-15.806-9.126-.929-.536v-.146l.615-.345 10.65-4.772z",
    transform: "translate(-184.489 -311.538)",
    style: {
      fill: "#013eb7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15970"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 849",
    d: "m252.474 275.925-.016.022-6.195 4.027-3.989 2.592H229.5l.295-.181 12.253-.732 10.409-5.739z",
    transform: "translate(-219.056 -266.334)",
    style: {
      fill: "#013eb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 850",
    d: "m253.43 244.192-10.409 5.739-12.253.732 2.177-1.334 3.822-2.345 4.224-2.589 1.575-.966-5.777-8.793.044-.025 15.65 9.034z",
    transform: "translate(-220.032 -234.61)",
    style: {
      fill: "#013eb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 851",
    d: "m262.423 243.512-1.575.966-4.157-2.4-.067.038v-7.383l.022-.013z",
    transform: "translate(-239.89 -234.694)",
    style: {
      fill: "#013eb7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15972"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 845",
    d: "M201.224 234.774v7.383l-10.34 5.97v8.755l-6.395 6.591v-19.038z",
    transform: "translate(-184.489 -234.736)",
    style: {
      fill: "#013eb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 852",
    d: "M190.941 333.367a423.609 423.609 0 0 0-5.837 3.172l-.615.345v-.219l6.395-6.591v3.261z",
    transform: "translate(-184.489 -307.929)",
    style: {
      fill: "#013eb7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 853",
    d: "M273.495 276.085v19.4l-16.8 9.7-.035-.019-.032-.051v-7.355l.067.038 10.406-6.008v-7.352l6.191-8.438.025-.016z",
    transform: "translate(-240.061 -266.386)",
    style: {
      fill: "#013eb7"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatachain);
export default __webpack_public_path__ + "static/media/creatachain.e4502042c2c5626da76403c3d09a8f48.svg";
export { ForwardRef as ReactComponent };